(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nll-contact"] && !Shopify.designMode) return;
  try {
    
const nllProductTitle=new URLSearchParams(window.location.search).get('prodotto');const nllMessage=document.getElementById('NllMessage');if(nllProductTitle&&nllMessage&&!nllMessage.value)nllMessage.value=nllProductTitle;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nll-footer"] && !Shopify.designMode) return;
  try {
    
function initNllRelationship(){const dialog=document.getElementById('nll-relationship');if(!dialog||dialog.dataset.ready)return;dialog.dataset.ready='true';let seen=false;try{seen=sessionStorage.getItem('nll-distributor-notice-v2')==='seen'}catch{}dialog.querySelectorAll('[data-nll-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));dialog.addEventListener('close',()=>{try{sessionStorage.setItem('nll-distributor-notice-v2','seen')}catch{}});if(!seen)dialog.showModal()}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initNllRelationship);else initNllRelationship();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nll-packages"] && !Shopify.designMode) return;
  try {
    
function initNllPackages(root=document){
  root.querySelectorAll('[data-nll-packages]').forEach(section=>{
    section.querySelectorAll('.nll-pack-form').forEach(form=>{
      if(form.dataset.ready)return;
      form.dataset.ready='true';
      const button=form.querySelector('button[type="submit"]');
      const initialLabel=button.textContent;
      const components=[...form.querySelectorAll('[data-component]')];
      const error=form.querySelector('[data-package-error]');
      const refresh=()=>{
        let total=0;
        let ready=form.dataset.complete==='true'&&components.length>0;
        components.forEach((input,index)=>{
          const selected=input.tagName==='SELECT'?input.selectedOptions[0]:input;
          if(!selected||selected.disabled||!input.value){ready=false;return;}
          total+=Number(selected.dataset.price||0);
          const link=input.closest('li').querySelector('[data-component-link]');
          if(link&&selected.dataset.url)link.href=selected.dataset.url;
          const image=form.closest('article').querySelector('[data-package-image="'+index+'"] img');
          if(image&&selected.dataset.image){image.src=selected.dataset.image;image.removeAttribute('srcset');image.alt=selected.textContent.trim();delete image.dataset.nllNormalized;}
        });
        form.querySelector('[data-package-total]').textContent=new Intl.NumberFormat(section.dataset.locale||'it',{style:'currency',currency:section.dataset.currency||'EUR'}).format(total/100);
        button.disabled=!ready;document.dispatchEvent(new Event('nll:package-images'));
      };
      components.forEach(input=>input.addEventListener('change',refresh));
      refresh();
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(button.disabled||form.dataset.busy)return;
        form.dataset.busy='true';
        button.disabled=true;
        button.textContent=form.dataset.pending;
        error.textContent='';
        const items=components.map(input=>({id:Number(input.value),quantity:1,properties:{Pacchetto:form.dataset.package}}));
        try{
          const response=await fetch(section.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||form.dataset.error);
          window.location.assign(section.dataset.cartUrl);
        }catch(problem){
          error.textContent=form.dataset.error+' '+(problem.message||'');
          delete form.dataset.busy;
          button.textContent=initialLabel;
          refresh();
        }
      });
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initNllPackages());else initNllPackages();
document.addEventListener('shopify:section:load',event=>initNllPackages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nll-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.matches('[data-nll-variant]')){const url=event.target.selectedOptions[0]?.dataset.url;if(url)window.location.assign(url)}});

  } catch(e) { console.error(e); }
})();
})();
